import InnerSection from "../components/team-dark/innser-section";

export default function TeamDark() {
	return <InnerSection />;
}